/**
 * Keeps phones at 1x so Plumb feels like an app, not a web page. The viewport meta in
 * index.html (maximum-scale=1, user-scalable=no) stops iOS zooming into focused fields, and
 * the iOS app's web view honors it for pinch too. Mobile Safari ignores user-scalable=no for
 * pinch, so its gesture events are cancelled here; `touch-action` in index.css covers the
 * other touch browsers and double-tap zoom. Touch screens only: Safari on a Mac sends the
 * same gesture events for trackpad pinch, which stays available on desktop.
 */
export function lockZoomOnTouch(): void {
  if (!window.matchMedia('(pointer: coarse)').matches) return
  const cancel = (e: Event) => e.preventDefault()
  for (const type of ['gesturestart', 'gesturechange', 'gestureend']) {
    document.addEventListener(type, cancel, { passive: false })
  }
}
